import { Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/hooks/use-auth'
import { AppShell, BackofficeHeader, BackofficeSidebar } from '@betstarters/ui'
import {
  LayoutDashboard, Building2, Tags, Users, Shield, KeyRound,
  ClipboardList, FileText, Package,
} from 'lucide-react'

export function IamAppShell() {
  const { t } = useTranslation()
  const { user, logout, isImpersonating, endImpersonation } = useAuth()
  const navigate = useNavigate()
  const role = user?.platform_role ?? 'BOOKMAKER_ADMIN'

  const sections = [
    {
      label: t('nav.sectionLabel'),
      items: [
        { to: '/', icon: LayoutDashboard, label: t('nav.dashboard'), visible: true },
        { to: '/tenants', icon: Building2, label: t('nav.tenants'), visible: role === 'PLATFORM_ADMIN' },
        { to: '/bookmakers', icon: Tags, label: t('nav.bookmakers'), visible: ['PLATFORM_ADMIN', 'TENANT_ADMIN'].includes(role) },
        { to: '/users', icon: Users, label: t('nav.users'), visible: true },
        { to: '/roles', icon: Shield, label: t('nav.roles'), visible: true },
        { to: '/permissions', icon: KeyRound, label: t('nav.permissions'), visible: ['PLATFORM_ADMIN', 'TENANT_ADMIN'].includes(role) },
        { to: '/assignments', icon: ClipboardList, label: t('nav.assignments'), visible: ['PLATFORM_ADMIN', 'TENANT_ADMIN'].includes(role) },
        { to: '/products', icon: Package, label: t('nav.products'), visible: role === 'PLATFORM_ADMIN' },
        { to: '/audit', icon: FileText, label: t('nav.auditLog'), visible: role === 'PLATFORM_ADMIN' },
      ],
    },
  ]

  const sidebar = (
    <BackofficeSidebar
      subtitle={t('appSubtitle')}
      sections={sections}
    />
  )

  const header = (
    <BackofficeHeader
      userEmail={user?.email}
      userRole={user?.platform_role}
      onLogout={logout}
      onProfileClick={() => navigate('/profile')}
      impersonation={isImpersonating ? {
        isImpersonating: true,
        email: user?.email,
        onEnd: endImpersonation,
        label: t('impersonating', { email: user?.email }),
        endLabel: t('endImpersonation'),
      } : undefined}
      showLanguageSwitcher
    />
  )

  return (
    <AppShell sidebar={sidebar} header={header}>
      <Outlet />
    </AppShell>
  )
}
